"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var inertia_react_1 = require("@inertiajs/inertia-react");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var AuthenticationCard_1 = __importDefault(require("@/Jetstream/AuthenticationCard"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
var Checkbox_1 = __importDefault(require("@/Jetstream/Checkbox"));
var Input_1 = __importDefault(require("@/Jetstream/Input"));
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var ValidationErrors_1 = __importDefault(require("@/Jetstream/ValidationErrors"));
function Register() {
    var page = (0, useTypedPage_1.default)();
    var route = (0, useRoute_1.default)();
    var form = (0, inertia_react_1.useForm)({
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        terms: false,
    });
    function onSubmit(e) {
        e.preventDefault();
        form.post(route('register'), {
            onFinish: function () { return form.reset('password', 'password_confirmation'); },
        });
    }
    return (react_1.default.createElement(AuthenticationCard_1.default, null,
        react_1.default.createElement(inertia_react_1.Head, { title: "Register" }),
        react_1.default.createElement(ValidationErrors_1.default, { className: "mb-4" }),
        react_1.default.createElement("form", { onSubmit: onSubmit },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Label_1.default, { htmlFor: "name" }, "Name"),
                react_1.default.createElement(Input_1.default, { id: "name", type: "text", className: "mt-1 block w-full", value: form.data.name, onChange: function (e) { return form.setData('name', e.currentTarget.value); }, required: true, autoFocus: true, autoComplete: "name" })),
            react_1.default.createElement("div", { className: "mt-4" },
                react_1.default.createElement(Label_1.default, { htmlFor: "email" }, "Email"),
                react_1.default.createElement(Input_1.default, { id: "email", type: "email", className: "mt-1 block w-full", value: form.data.email, onChange: function (e) { return form.setData('email', e.currentTarget.value); }, required: true })),
            react_1.default.createElement("div", { className: "mt-4" },
                react_1.default.createElement(Label_1.default, { htmlFor: "password" }, "Password"),
                react_1.default.createElement(Input_1.default, { id: "password", type: "password", className: "mt-1 block w-full", value: form.data.password, onChange: function (e) { return form.setData('password', e.currentTarget.value); }, required: true, autoComplete: "new-password" })),
            react_1.default.createElement("div", { className: "mt-4" },
                react_1.default.createElement(Label_1.default, { htmlFor: "password_confirmation" }, "Confirm Password"),
                react_1.default.createElement(Input_1.default, { id: "password_confirmation", type: "password", className: "mt-1 block w-full", value: form.data.password_confirmation, onChange: function (e) {
                        return form.setData('password_confirmation', e.currentTarget.value);
                    }, required: true, autoComplete: "new-password" })),
            page.props.jetstream.hasTermsAndPrivacyPolicyFeature && (react_1.default.createElement("div", { className: "mt-4" },
                react_1.default.createElement(Label_1.default, { htmlFor: "terms" },
                    react_1.default.createElement("div", { className: "flex items-center" },
                        react_1.default.createElement(Checkbox_1.default, { name: "terms", id: "terms", checked: form.data.terms, onChange: function (e) { return form.setData('terms', e.currentTarget.checked); } }),
                        react_1.default.createElement("div", { className: "ml-2" },
                            "I agree to the",
                            react_1.default.createElement("a", { target: "_blank", href: route('terms.show'), className: "underline text-sm text-gray-600 hover:text-gray-900" }, "Terms of Service"),
                            "and",
                            react_1.default.createElement("a", { target: "_blank", href: route('policy.show'), className: "underline text-sm text-gray-600 hover:text-gray-900" }, "Privacy Policy")))))),
            react_1.default.createElement("div", { className: "flex items-center justify-end mt-4" },
                react_1.default.createElement(inertia_react_1.InertiaLink, { href: route('login'), className: "underline text-sm text-gray-600 hover:text-gray-900" }, "Already registered?"),
                react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)('ml-4', { 'opacity-25': form.processing }), disabled: form.processing }, "Register")))));
}
exports.default = Register;
